import { type JSX } from 'react';
import { useGate, useUnit } from 'effector-react';
import {
  Autocomplete,
  FormControl,
  FormHelperText,
  FormLabel,
  TextField,
  CircularProgress,
} from '@mui/material';
import { Listbox } from '@features/effector-form/components/listbox';
import { withControl } from '@features/effector-form/hoc/withControl';
import { SimpleListControlGate, $data, $pending } from './model';

type Props = {
  parent_guids?: string | string[];
};

export const SimpleListControl = withControl<Props>(
  ({
    value,
    setValue,
    error,
    label,
    required,
    readOnly,
    disabled,
    isError,
    parent_guids = null,
  }) => {
    useGate(SimpleListControlGate, { parent_guids });

    const [data, pending] = useUnit([$data, $pending]);
    const val =
      value !== ''
        ? data?.find((item) =>
            typeof value === 'object' ? item.id === value?.id : item.id === value
          )
        : null;

    return (
      <FormControl required={required} disabled={disabled}>
        {label && <FormLabel error={isError}>{label}</FormLabel>}
        <Autocomplete
          loading={pending}
          value={!data ? null : val || null}
          options={Array.isArray(data) ? data : []}
          onChange={(_: unknown, newValue: any) => {
            setValue(newValue || null);
          }}
          slotProps={{
            listbox: {
              component: Listbox,
            },
          }}
          renderInput={(params): JSX.Element => (
            <TextField
              {...params}
              slotProps={{
                input: {
                  ...params.InputProps,
                  readOnly,
                  error: isError,
                  endAdornment: readOnly ? null : (
                    <>
                      {pending && <CircularProgress size={20} color="inherit" />}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                },
              }}
            />
          )}
          readOnly={readOnly}
          disabled={disabled}
        />
        {error && <FormHelperText error>{error}</FormHelperText>}
      </FormControl>
    );
  }
);
